// extracted by mini-css-extract-plugin
export default {"courseTeachers":"CourseTeachers_courseTeachers__zhlS0","teacherList":"CourseTeachers_teacherList__O22AS"};